import styled from '@emotion/styled/macro'

export const RecurrenceCheckboxWrapper = styled.div<{ checked: boolean }>`
  background-color: ${({ checked }) =>
    checked ? 'rgba(0, 92, 217,0.3)' : '#fff'};
  border-radius: 4px;
  display: flex;
  margin-bottom: 1.5rem;
  padding: 0.5rem;
  width: 400px;
  :hover {
    background-color: rgba(0, 92, 217, 0.14);
  }
`

export const RecurrenceOptionsWrapper = styled.div`
  display: flex;
`

export const RecurrenceCheckbox = styled.input`
  height: 18px;
  margin: 0;
  width: 18px;
`

export const RecurrenceLabel = styled.label<{ checked?: boolean }>`
  color: ${({ checked }) => (checked ? '#005cd9' : '#3c4043')};
  display: block;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  letter-spacing: 0.25px;
  line-height: 18px;
  margin-left: 8px;
  opacity: 1;
  text-decoration: none;
  text-transform: none;
`

export const RecurrenceOptionsLabel = styled(RecurrenceLabel)`
  padding: 1rem 0.7rem;
`
